/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search-dark': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<path pid="0" d="M12.15 13.057a1 1 0 0 1 1.322-.005l.089.089 4.782 5.387a1 1 0 0 1-1.407 1.416l-.089-.089-4.782-5.386a1 1 0 0 1 .084-1.412z" _fill="#0076DD"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M1 7.821C1 3.513 4.333 0 8.47 0c4.139 0 7.471 3.513 7.471 7.821s-3.332 7.821-7.47 7.821S1 12.13 1 7.822zm12.941 0C13.941 4.595 11.48 2 8.471 2 5.46 2 3 4.595 3 7.821c0 3.226 2.461 5.821 5.47 5.821 3.01 0 5.471-2.595 5.471-5.82z" _fill="#789ECC"/>'
  }
})
